import { OrderIncompleteDeliveryReason } from '@/models/OrderIncompleteDelivery';
import { OrderStatus } from '@/models/OrderStatus';

export enum OrderAttentionKind {
  IncompleteDelivery = 'INCOMPLETE_DELIVERY',
  UnactionedOrder = 'UNACTIONED_ORDER',
}

export interface OrderAttentionItem {
  kind: OrderAttentionKind;
  orderId: string;
  orderCode: string;
  storeId: string;
  storeName: string;
  status: OrderStatus;
  occurredAt: Date;
  hoursWaiting?: number | null;
  incompleteDeliveryId?: string | null;
  incompleteReason?: OrderIncompleteDeliveryReason | null;
  lastStatusChangedAt?: Date | null;
}

export interface OrderAttentionItems {
  items: OrderAttentionItem[];
  totalCount?: number;
  estimatedTotalCount: number;
}
